export const svgIcons = [
	'chev-left',
	'chev-right',
	'chev-down',
	'chev-up',
	'heart-people',
	'location',
	'logo-header',
	'map-marker',
	'menu',
	'mail',
	'neck-stand-necklace',
	'people-in-hands',
	'search-icon',
	'transparent-box',
	'cartIcon',
	"compare",
	'heartIcon',
	'userIcon',
	'star',
	'edit',
	'delete',
	'delivery',
	'7-day-return',
	'box',
	'heart-empty',
	'genuine',
	'hallmark',
	'purity',
	'tick',
	'ratingStarLight',
	'ratingStarDark',
	'starYellow',
	'chev-right-circle',
	'comment',
	'chev-right-menu',
	'heart-filled',
	'partialPayment',
	'purpleheart-filled',
	'commnet1',
	'commnet2Filled',
	'newHeartIcnEmpty',
	'newHeartIcnFill',
	'newcommentfill',
	'newLikeFill',
	'newcommentEmpty',
	'newlikeEmpty',
	'mobile-home',
	'mobile-store',
	'mobile-studio',
	'backArrow',
	'frontArrow',
	'myOrders',
	'appointement',
	'myCart',
	'mobile-profile',
	'myProfile',
	'myAddress',
	'mobile-compare',
	'mobile-collection'
];
